<template>
  <ui-modal
    v-if="user"
    @close="handleClose"
    title="Notifications"
    class="ui-modal--push-notification"
    :closable="true">
    <template slot="default">
      <p v-if="user.type === 1">COOLOC pourra vous indiquer des informations et des opérations importantes concernant votre location.</p>
      <p v-else>COOLOC pourra vous indiquer des informations et des opérations importantes concernant vos biens et vos locataires.</p>
      <p>Autorisez-vous COOLOC à vous envoyer des notifications ?</p>
    </template>

    <template slot="buttons">
      <ui-button type="button" class="red-button" @click="handleAccept">
        Autoriser
      </ui-button>
    </template>

    <template slot="footer">
      <p>Vous pouvez modifier ce choix à tout moment dans les paramètres de votre navigateur.</p>
    </template>
  </ui-modal>
</template>

<script>
import { subscribeUser } from '@/service'

export default {
  name: 'push-notification-popup',
  props: {
    user: {
      type: Object,
    },
  },
  methods: {
    handleClose() {
      this.$emit('close', 'cancelled')
    },
    async handleAccept() {
      try {
        const success = await subscribeUser(this.user)
        if (success) {
          console.log('Push notification subscription successful')
          this.$emit('close', true)
          this.$emit('subscribed', true)
        } else {
          console.warn('Push notification subscription failed')
          this.$emit('close', false)
          this.$emit('subscribed', false)
        }
      } catch (error) {
        console.error('Error subscribing to push notifications:', error)
        this.$error("Une erreur est survenue lors de l'activation des notifications")
        this.$emit('close', false)
        this.$emit('subscribed', false)
      }
    },
  },
  components: {
    UiButton: require('@/ui/Button').default,
    UiModal: require('@/ui/Modal').default,
  },
}
</script>
